<div class="info-card" [class.info-card--disabled]="disabled()">
  <header
    class="info-card__header"
    [class.info-card__header--hidden]="!header()"
  >
    <ng-content select="[info-card-header]" />
  </header>

  <div class="info-card__body">
    <ng-content select="[info-card-item]" />
  </div>

  <footer
    class="info-card__footer"
    [class.info-card__footer--hidden]="!footer()"
  >
    <ng-content select="[info-card-footer]" />
  </footer>
</div>
